// extracted by mini-css-extract-plugin
export default {"calendar":"Calendar_calendar__4xLVT"};